module.exports = __webpack_public_path__ + "media/images/talent/story-03-fdec0e621779d252859aa02e3187c6de.png";